import * as React from 'react';
import { DocumentationPage } from './DocumentationPage';

export const PublisherDocumentation: React.FC = () => (
    <DocumentationPage title='Publisher Documentation' articleType='publisher'></DocumentationPage>  
);